/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2023-11-17 09:05:48
 * @LastEditTime : 2023-11-23 14:28:44
 * @LastEditors  : yangxr
 * @Description  : 处罚台账API
 * @FilePath     : \icps_fb\src\api\smart\penaltyLedger.js
 */
export const queryPage = '/icps/system/sign/intelligent/fine/QueryPage'
export const Download = '/icps/system/sign/intelligent/invoice/exportInvoice'
import request from '@/utils/request'
// 保存发票
export function saveOrUpdate(data) {
    return request({
        url: '/icps/system/sign/intelligent/fine/saveOrUpdate',
        method: 'POST',
        data
    })
}
// 查询合同
export function getContract(data) {
    return request({
        url: '/icps/system/sign/dataCollection/contract/QueryPage',
        method: 'POST',
        data
    })
}
// 删除
export function batchDel(data) {
    return request({
        url: '/icps/system/sign/intelligent/fine/batchDel',
        method: 'POST',
        data
    })
}
//  修改状态
export function batchUpdateStatus(params) {
    return request({
        url: '/icps/system/sign/intelligent/fine/batchUpdateStatus',
        method: 'get',
        params
    })
}
export function queryListsByPid(data) {
    //查询list协作单位
    return request({
      url: "/icps/system/sign/dataCollection/cooperation/queryListsByPid",
      method: "post",
      data,
    });
  }
